import React from "react";
import Header from "../shared/header"
import Footer from "../shared/footer"

class Home extends React.Component{
    render(){
        return(
            
        <body>
          <Header/>
          


          
            {/* <!-- ======= Hero Section ======= --> */}
            <section id="hero" class="d-flex align-items-center">
          
              <div class="container">
                <div class="row">
                  <div class="col-lg-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex flex-column justify-content-center">
                    <h1>Learn with us and collaborate on projects</h1>
                    <h2>We are team of students having varied experience collaborating together for projects and peer to peer learning</h2>
                    <div class="d-flex">
                      <a href="https://forms.gle/AQfn4jDr4b9T7jtb6" class="btn-get-started scrollto">Now Recruiting !</a>
                      <a href="https://youtu.be/a0pIsZfvxAY" class="glightbox btn-watch-video"><i class="bi bi-play-circle"></i><span>Watch Video</span></a>
                    </div>
                  </div>
                  <div class="col-lg-6 order-1 order-lg-2 hero-img">
                    <img src="assets/img/hero-img.png" class="img-fluid animated" alt=""/>
                  </div>
                </div>
              </div>
          
            </section>
            {/* <!-- End Hero --> */}
            

          
            <main id="main">
          
              {/* <!-- ======= Featured Services Section ======= --> */}
              <section id="featured-services" class="featured-services">
                <div class="container">
          
                  <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <div class="icon-box">
                        <div class="icon"><i class="bi bi-laptop"></i></div>
                        <h4 class="title"><a href="">Team Web-Dev</a></h4>
                        <p class="description">A group of sleep deprived and caffeine loving people, who love to sit together and find insects in their computers. Our most time is spend in finding and fixing the bug. Occasionally we write some code also.</p>
                      </div>
                    </div>
                    
                    <div class="col-lg-4 col-md-6 mt-4 mt-md-0">
                      <div class="icon-box">
                        <div class="icon"><i class="bi bi-card-checklist"></i></div>
                        <h4 class="title"><a href="">Team Coding</a></h4>
                        <p class="description">Learn new languages and data structures to enable optimisation of scripts. regular discussions and collaborations on prjects and particiapte in coding competitions</p>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mt-4 mt-lg-0">
                      <div class="icon-box">
                        <div class="icon"><i class="bi bi-clipboard-data"></i></div>
                        <h4 class="title"><a href="">Team Editorial</a></h4>
                        <p class="description">The Editorial Team aims to educate our student community on the latest technology trends and skills. We want to facilitate students in enhancing their creative and writing abilities and foster in them social skills essential for any working professional in this day and age. </p>
                      </div>
                    </div>
                  </div>
          
                </div>
              </section>
              <br/>
              
              {/* 2nd row of domains */}

              <section id="featured-services" class="featured-services">
                <div class="container">
          
                <div class="row">
                    <div class="col-lg-4 col-md-6">
                      <div class="icon-box">
                        <div class="icon"><i class="bi bi-laptop"></i></div>
                        <h4 class="title"><a href="">Team AI</a></h4>
                        <p class="description">Sub Domains:
                        <br/>
                        NLP
                        <br/>
                        Social Network Analysis
                        <br/>
                        signal Processing
                        <br/>
                        control theory
                        <br/>
                        Bioinformatics
                        <br/>
                        cryptography
                        </p>
                      </div>
                    </div>
                    
                    <div class="col-lg-4 col-md-6 mt-4 mt-md-0">
                      <div class="icon-box">
                        <div class="icon"><i class="bi bi-card-checklist"></i></div>
                        <h4 class="title"><a href="">Team Management</a></h4>
                        <p class="description">The Management team is the backbone of the club as it takes care of all the in-house discipline , help in the documentation along with the heads and create various types of events(brainstorm). It coordinates with all the domains to ensure everyone is giving their best in maintaining the club.   </p>
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mt-4 mt-lg-0">
                      <div class="icon-box">
                        <div class="icon"><i class="bi bi-clipboard-data"></i></div>
                        <h4 class="title"><a href="">Team Design</a></h4>
                        <p class="description">Content designers research the audience so that they can design effective content for them. They serve as advocates for users in the engineering and design processes. They try to make it simple for that audience to find the content they need. They also manage the content to keep it useful and up to date.</p>
                      </div>
                    </div>
                  </div>
          
                </div>
              </section>
              {/* <!-- End Featured Services Section --> */}
          
              <section id="about" class="about">
                <div class="container">
          
                  <div class="row">
                    <div class="col-lg-6">
                      <img src="assets/img/about.png" class="img-fluid" alt=""/>
                    </div>
                    <div class="col-lg-6 pt-4 pt-lg-0 content">
                      <h3>Why join cosmos and what we do ?</h3>
                      
                      <ul>
                        <li><i class="bi bi-check-circle"></i>  Provide an environment with numerous peers who are motivated to work together</li>
                        <li><i class="bi bi-check-circle"></i>  Learn from the basics and move up to create projects that could potentially make a change</li>
                        <li><i class="bi bi-check-circle"></i>  There’s no arguing that organizations and activities look good on a résumé. Showing employers that you participated in, or (better yet) lead, a student organization, they’ll know that you’re hard working and can handle multiple responsibilities. </li>
                      </ul>
                      <p>
                      With multiple domains to chose from. you can explore your interests freely to evaluate what you would like to pursue in the future
                      </p>
                    </div>
                  </div>
          
                </div>
              </section>
              {/* <!-- End About Section -->

          
              {/* <!-- ======= Cta Section ======= --> */}
              <section id="cta" class="cta">
                <div class="container">
          
                  <div class="text-center">
                    <h3>Subscribe to our Medium Page</h3>
                    <p> Curated content about latest developments in tech and information about our club activities . So make sure to subscribe to never miss out on the action.</p>
                    <a class="cta-btn" href="https://cosmos-iitm.medium.com/">Visit</a>
                  </div>
          
                </div>
              </section> 
              {/* <!-- End Cta Section --> */}
          
              {/* <section id="team" class="team section-bg">
                <div class="container">
          
                  <div class="section-title">
                    <span>Team</span>
                    <h2>Team</h2>
                    <p>Sit sint consectetur velit quisquam cupiditate impedit suscipit alias</p>
                  </div>
          
                  <div class="row">
                    <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                      <div class="member">
                        <img src="assets/img/team/team-1.jpg" alt=""/>
                        <h4>ANON</h4>
                        <span>Chief Executive Officer</span>
                        <p>
                          Magni qui quod omnis unde et eos fuga et exercitationem. Odio veritatis perspiciatis quaerat qui aut aut aut
                        </p>
                        <div class="social">
                          <a href=""><i class="bi bi-twitter"></i></a>
                          <a href=""><i class="bi bi-facebook"></i></a>
                          <a href=""><i class="bi bi-instagram"></i></a>
                          <a href=""><i class="bi bi-linkedin"></i></a>
                        </div>
                      </div>
                    </div>
          
                    <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                      <div class="member">
                        <img src="assets/img/team/team-2.jpg" alt=""/>
                        <h4>ANON</h4>
                        <span>Product Manager</span>
                        <p>
                          Repellat fugiat adipisci nemo illum nesciunt voluptas repellendus. In architecto rerum rerum temporibus
                        </p>
                        <div class="social">
                          <a href=""><i class="bi bi-twitter"></i></a>
                          <a href=""><i class="bi bi-facebook"></i></a>
                          <a href=""><i class="bi bi-instagram"></i></a>
                          <a href=""><i class="bi bi-linkedin"></i></a>
                        </div>
                      </div>
                    </div>
          
                    <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                      <div class="member">
                        <img src="assets/img/team/team-3.jpg" alt=""/>
                        <h4>ANON</h4>
                        <span>CTO</span>
                        <p>
                          Voluptas necessitatibus occaecati quia. Earum totam consequuntur qui porro et laborum toro des clara
                        </p>
                        <div class="social">
                          <a href=""><i class="bi bi-twitter"></i></a>
                          <a href=""><i class="bi bi-facebook"></i></a>
                          <a href=""><i class="bi bi-instagram"></i></a>
                          <a href=""><i class="bi bi-linkedin"></i></a>
                        </div>
                      </div>
                    </div>
          
                  </div>
          
                </div>
              </section>
              {/* <!-- End Team Section -->
           */}
              {/* <!-- ======= Contact Section ======= --> */}
              <section id="contact" class="contact">
                <div class="container">
          
                  <div class="section-title">
                    <span>Contact</span>
                    <h2>Contact</h2>
                  </div>
          
                  <div class="row">
          
                    <div class="col-lg-5 d-flex align-items-stretch">
                      <div class="info">
                        {/* <div class="address">
                          <i class="bi bi-geo-alt"></i>
                          <h4>Location:</h4>
                          <p>On the Internet</p>
                        </div> */}
          
                        <div class="email">
                          <i class="bi bi-envelope"></i>
                          <h4>Club Email:</h4>
                          <p>iitm.cosmos@gmail.com</p>
                        </div>

                        <div class="email">
                          <i class="bi bi-envelope"></i>
                          <h4>Chairperson:</h4>
                          <p>Akhil Srinivas p
                          <br/>
                          21f100203@student.onlinedegree.iitm.ac.in</p>
                        </div>

                        <div class="email">
                          <i class="bi bi-envelope"></i>
                          <h4>Vice-chairperson:</h4>
                          <p>Aditya Maltare 
                          <br/>
                          21f2000292@student.onlinedegree.iitm.ac.in</p>
                        </div>
          
                        {/* <div class="phone">
                          <i class="bi bi-phone"></i>
                          <h4>Call:</h4>
                          <p>+91 **********</p>
                        </div> */}
          
                      </div>
          
                    </div>
          
                    <div class="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
                      {/* <form action="forms/contact.php" method="post" role="form" class="php-email-form">
                        <div class="row">
                          <div class="form-group col-md-6">
                            <label for="name">Your Name</label>
                            <input type="text" name="name" class="form-control" id="name" required/>
                          </div>
                          <div class="form-group col-md-6 mt-3 mt-md-0">
                            <label for="name">Your Email</label>
                            <input type="email" class="form-control" name="email" id="email" required/>
                          </div>
                        </div>
                        <div class="form-group mt-3">
                          <label for="name">Subject</label>
                          <input type="text" class="form-control" name="subject" id="subject" required/>
                        </div>
                        <div class="form-group mt-3">
                          <label for="name">Message</label>
                          <textarea class="form-control" name="message" rows="10" required></textarea>
                        </div>
                        <div class="my-3">
                          <div class="loading">Loading</div>
                          <div class="error-message"></div>
                          <div class="sent-message">Your message has been sent. Thank you!</div>
                        </div>
                        <div class="text-center"><button type="submit">Send Message</button></div>
                      </form> */}
                      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSc9zgejP67VpKhUYyO-VZ3B2FGTzy73jQN3jDwdbhnzLZX5IQ/viewform?embedded=true" width="640" height="1131" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
                    </div>
          
                  </div>
          
                </div>
              </section>
              {/* <!-- End Contact Section --> */}
          
            </main>
            {/* <!-- End #main --> */}

            <Footer/> 

        </body>
        

        );
    }
} 

export default Home
